import * as React from 'react';
import classNames from 'classnames';
import { TABLE_DEFAULT_NAME } from './TableDefaults';
import { SeparateTableInterface } from './Table.interfaces';

const SingleTable = <T extends {}>(props: SeparateTableInterface<T>) => {
  const { noBorder, tableName, autoid, data, headerRenderer, footerRenderer, draggableId, onDragEnd,
    emptyText, ifEmpty, cellRenderer, originalWord, replacementWord, metadata, tableClassName,
    updateRowPosition, filteredData, TBody, TableRow, hiddenColumns, className, isEmpty, TableHeader } = props;

  return (<table
    className={classNames(tableClassName, className, noBorder && `${tableClassName}--no-border`)}
    id={tableName}
    data-autoid={autoid}
  >
    <TableHeader
      data={data}
      tableName={tableName || TABLE_DEFAULT_NAME}
      metadata={metadata}
      hiddenColumns={hiddenColumns}
      cellRenderer={headerRenderer}
    />
    <TBody onDragEnd={draggableId ? updateRowPosition : onDragEnd}>
      {isEmpty && ifEmpty(metadata, emptyText)}
      {!isEmpty &&
        [...(filteredData || data)].map((singleRow: any, i: number) => (
          <TableRow key={i}>
            {cellRenderer(tableName || TABLE_DEFAULT_NAME, singleRow, metadata, i,
              hiddenColumns, originalWord, replacementWord)}
          </TableRow>
        ))}
    </TBody>
    {footerRenderer && <tfoot>{footerRenderer(metadata, hiddenColumns)}</tfoot>}
  </table>);
};

export default SingleTable;
export { SingleTable };
